<ng-progress
  #progressBar
  [trickleSpeed]="10"
  [speed]="10"
  [spinner]="false"
  color="#1C84EE"
></ng-progress>
<router-outlet></router-outlet>
